/**
 * renameJobHelpers.ts
 * This file contains utility functions to handle rename job status checks.
 */
import { JobStatusType } from '../../../../api-client/autogenerated';

export type RenameJob = {
  status?: JobStatusType;
  percent?: number;
};

export function isRenameJobComplete(job?: RenameJob): boolean {
  if (!job) return false;
  return (
    job.status === JobStatusType.Complete ||
    job.status === JobStatusType.Canceled ||
    job.percent === 100
  );
}

export function isRenameJobRunning(job?: RenameJob): boolean {
  if (!job) return false;
  return (
    job.status !== JobStatusType.Complete &&
    job.status !== JobStatusType.Canceled &&
    (job.percent ?? 0) < 100
  );
}
